export function deepClone<T extends Object>(obj: T) {
  if (typeof obj !== 'object') {
    throw Error('[deepClone]: argument `obj` is not defined')
  }
  return JSON.parse(JSON.stringify(obj))
}
